// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","textAreaWrapper":"JobFilesPublication__textAreaWrapper--zw","textArea":"JobFilesPublication__textArea--iA","notice":"JobFilesPublication__notice--bp"};